import { Alert } from '@mantine/core';
import { IconClockHour4, IconLock } from '@tabler/icons-react';

import { licenceNotice, useLicence } from './licence';

/** Bandeau en haut des pages : essai, fin d'abonnement proche, lecture seule.
 * Jamais imprimé (rapports, reçus, ordonnances…). */
export function LicenceBanner() {
  const { data } = useLicence();
  const notice = licenceNotice(data);
  if (!notice) return null;
  const Icon = notice.locked ? IconLock : IconClockHour4;
  return (
    <Alert
      color={notice.color}
      icon={<Icon size={18} />}
      title={notice.title}
      mb="md"
      className="no-print"
      role={notice.locked ? 'alert' : 'status'}
      py="xs"
    >
      {notice.text}
    </Alert>
  );
}
